<template>
  <div class="col-12">
    <div
      class="group-input col-12 column q-mt-sm"
    >
      <RequiredLabel
        title="Houve movimentação de terminal?"
        name=""
      />
      <div class="flex row justify-around">
        <q-radio
          keep-color
          v-model="requestData.movimentTerminal"
          size="lg"
          :val="1"
          label="Sim"
          color="red-6"
        />
        <q-radio
          keep-color
          size="lg"
          v-model="requestData.movimentTerminal"
          :val="0"
          label="Não"
          color="red-6"
        />
      </div>
    </div>
    <div
      v-if="isMovimentTerminal"
      class="group-input col-12 row q-mt-sm"
    >
      <label for="action">Ação</label>
      <q-select
        id="action"
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        ref="typeOSRef"
        v-model="requestData.action"
        color="red-9"
        use-input
        hide-selected
        placeholder="Selecione"
        emit-value
        fill-input
        input-debounce="0"
        :options="actionOptions.filter((item) => item.id_acao !== 3)"
        map-options
        option-value="id_acao"
        option-label="desc_acao"
        bg-color="white"
        lazy-rules
        name="action"
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div
      v-if="isMovimentTerminal"
      class="group-input col-12 row q-mt-sm"
    >
      <label for="state">Estado</label>
      <q-select
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        hide-selected
        placeholder=""
        fill-input
        input-debounce="0"
        bg-color="white"
        lazy-rules
        emit-value
        name="state"
        map-options
        v-model="requestData.state"
        :options="optionsStateEquipaments"
        option-value="id_estado_equipamento"
        option-label="desc_estado_equipamento"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm"  v-if="isMovimentTerminal">
      <label for="type-os">Código de baixa</label>
      <q-select
        id="type-os"
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        ref="typeOSRef"
        v-model="requestData.writeOffCode"
        color="red-9"
        use-input
        hide-selected
        disable
        fill-input
        input-debounce="0"
        :options="listWriteOffCode"
        option-value="value"
        option-label="text"
        bg-color="white"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm" v-if="isMovimentTerminal && requestData.action !== ''">

      <RequiredLabel
        title="Número do equipamento Instalado"
        name="equipamentNumberInstall"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        hide-selected
        placeholder=""
        v-model="requestData.equipamentNumberInstall"
        name="equipamentNumberInstall"
        fill-input
        input-debounce="0"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm" v-if="isMovimentTerminal && requestData.action === 1">
      <RequiredLabel
        title="Número do equipamento Desinstalado"
        name="equipamentNumberDesinstall"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        hide-selected
        placeholder=""
        name="equipamentNumberDesinstall"
        v-model="requestData.equipamentNumberUninstall"
        fill-input
        input-debounce="0"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 column q-mt-sm" v-if="isMovimentTerminal">
      <RequiredLabel
        title="Foi necessário trocar o SmartCard?"
        name="changeSmartcard"
      />
      <div class="flex row justify-around">
        <q-radio
          keep-color
          size="lg"
          v-model="smartcardChange"
          :val="1"
          label="Sim"
          color="red-6"
          :disable="requestData.action === ''"
        />
        <q-radio
          keep-color
          size="lg"
          :val="0"
          label="Não"
          v-model="smartcardChange"
          color="red-6"
          :disable="requestData.action === ''"
        />
      </div>
    </div>
    <div class="group-input col-12 row q-mt-sm" v-if="isMovimentTerminal && isChangeSmartCard && requestData.action !== ''">
      <RequiredLabel
        title="Número do SmartCard Instalado"
        name="cardNumberInstall"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        hide-selected
        placeholder=""
        fill-input
        v-model="requestData.cardNumberInstall"
        name="cardNumberInstall"
        type="number"
        input-debounce="0"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm" v-if="isMovimentTerminal && isChangeSmartCard && requestData.action === 1">
      <RequiredLabel
        title="Número do SmartCard Desinstalado"
        name="cardNumberUninstall"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        v-model="requestData.cardNumberUninstall"
        name="cardNumberUninstall"
        hide-selected
        placeholder=""
        fill-input
        type="number"
        input-debounce="0"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
  </div>
</template>

<script>
  import { computed, ref } from "vue";
import RequiredLabel from "../RequiredLabel.vue";

  export default {
    name: "MduFinishServiceForm",
    components: {
      RequiredLabel,
    },
    props: {
      requestData: Object,
      actionOptions: Array,
      listWriteOffCode: Array,
      optionsStateEquipaments: Array,
    },

    setup(props, { emit }) {
      const isMovimentTerminal = computed(() => {
        return props.requestData.movimentTerminal === 1;
      });

      const smartcardChange = ref(0);
      const isChangeSmartCard = computed(() => {
        return smartcardChange.value === 1;
      });
      

      return {
        isMovimentTerminal,
        smartcardChange,
        isChangeSmartCard,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }

  .q-page-container {
    padding-bottom: 0px !important;
  }

  .label-checkbox-confirm {
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 14px !important;
    letter-spacing: 0.01em !important;
    color: #999999 !important;
  }

  footer {
    background: #e5e5e5 !important;
    height: 12vh;

    .q-toolbar {
      height: 12vh;
    }

    .div-progress {
      height: 8vh;
    }

    .div-btn-next {
      height: 8vh;
    }
  }

  .section-service {
    width: 100%;

    .panel-services {
      background: transparent !important;
      overflow: hidden !important;

      .title-page {
        font-weight: bold;
        font-size: 18px;
        line-height: 19px;
        text-transform: uppercase;
        color: #e2262d;
      }

      .group-input {
        label {
          font-weight: bold;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.4);
        }
      }

      .label-requests-number {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.5);
      }

      .label-requests-description {
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
</style>
